<template>
  <div class="home">
    <div class="d-flex align-center justify-center">
      <img
        alt="Vue logo"
        src="../assets/logo.png">
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>

img {
  max-width: 80%;
}
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
